<template>
  <div>
    <div id="gantt-header" class="h-12 p-2 flex items-center">
      <h1 class="text-xl font-bold" style="margin-right: 10px;">KERP Gantt Chart</h1>
      <button
          @click="addTask"
          class="bg-indigo-700 hover:bg-indigo-900 text-white py-2 px-4 rounded-lg flex items-center">
        <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        <span class="font-bold text-xs">
            タスクを追加する
          </span>
      </button>
      <teleport to="#form">
        <div class="base" v-show="showDialog">
          <div class="overlay" v-show="showDialog" @click="showDialog=false">
          </div>
          <div class="content" v-show="showDialog">
            <h2 class="font-bold" v-if="update_mode">タスクの更新</h2>
            <h2 class="font-bold" v-else>タスクの追加</h2>
            <div class="my-4">
              <label class="text-xs">カテゴリーID:</label>
              <select v-model="form.category_id" class="text-xs border px-4 py-2 rounded-lg">
                <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}
                </option>
              </select>
              <div v-if="errors.category_id" class="text-red-500 text-xs mt-1">{{ errors.category_id }}</div>
            </div>
            <div class="my-4">
              <label class="text-xs">タスク名:</label>
              <input class="text-xs border rounded-lg px-4 py-2" v-model="form.F1">

              <div v-if="errors.F1" class="text-red-500 text-xs mt-1">{{ errors.F1 }}</div>
            </div>
            <div class="my-4">
              <label class="text-xs">担当者:</label>
              <select v-model="form.user_id" class="text-xs border px-4 py-2 rounded-lg">
                <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}
                </option>
              </select>

              <div v-if="errors.user_id" class="text-red-500 text-xs mt-1">{{ errors.user_id }}</div>
            </div>
            <div class="my-4">
              <label class="text-xs">開始日:</label>
              <input class="text-xs border rounded-lg px-4 py-2" v-model="form.start_date" type="date">

              <div v-if="errors.start_date" class="text-red-500 text-xs mt-1">{{ errors.start_date }}</div>
            </div>
            <div class="my-4">
              <label class="text-xs">完了期限日:</label>
              <input class="text-xs border rounded-lg px-4 py-2" v-model="form.end_date" type="date">

              <div v-if="errors.end_date" class="text-red-500 text-xs mt-1">{{ errors.end_date }}</div>
            </div>
            <div v-if="update_mode" class="flex items-center justify-between">
              <button
                  @click="updateTask()"
                  class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-lg text-xs flex items-center">
                <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                <span class="text-xs font-bold text-white">タスクを更新</span>
              </button>
              <button @click="deleteTask(this.form.id)"
                      class="bg-red-500 hover:bg-red-700 text-white py-2 px-4 rounded-lg flex items-center ml-2">
                <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                <span class="text-xs font-bold text-white">タスクを削除</span>
              </button>
            </div>
            <div v-else>
              <button
                  @click="saveTask"
                  class="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg flex items-center">
                <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                <span class="font-bold text-xs">
                  タスクを追加する
                </span>
              </button>
            </div>
            <div v-if="apiErrorMsg" class="text-red-500 text-xs mt-1">{{ apiErrorMsg }}</div>
          </div>
          <div v-if="loading" class="spinner-overlay">
            <div class="spinner"></div>
          </div>
        </div>
      </teleport>
    </div>
    <div style="padding: 0 10px">
      <p v-if="apiErrorMsgForHome" style="color: #bf0000; font-size: 20px">{{apiErrorMsgForHome}}</p>
    </div>
    <GanttChart
        :tasks-list="tasks"
        :categories="categories"
        :clickable="true"
        @editTask="editTask"
        @taskUpdated="updateDraggedTask"
        :resizable="true"
        :draggable="true"
    />
  </div>
</template>

<script>
import GanttChart from "@/components/GanttChartComponent.vue";

export default {
  components: {GanttChart},
  data() {
    return {
      categories: [
        {id: 1, name: 'ウェブ開発', collapsed: false},
        {id: 2, name: 'モバイルアプリ', collapsed: false},
        {id: 3, name: 'マーケティング', collapsed: false},
        {id: 4, name: 'テスト', collapsed: false},
      ],
      users: [
        {id: 1, name: '田中太郎'},
        {id: 2, name: '佐藤花子'},
        {id: 3, name: '鈴木一郎'},
        {id: 4, name: '山田美咲'},
      ],
      tasks: [
        {
          id: 1,
          category_id: 1,
          F1: 'フロントエンド開発',
          start_date: '2025-07-03',
          end_date: '2025-07-17',
          incharge_user: '田中太郎',
          user_id: 1,
          percentage: 0,
          db_id: 1
        },
        {
          id: 2,
          category_id: 1,
          F1: 'バックエンドAPI開発',
          start_date: '2025-07-07',
          end_date: '2025-07-10',
          incharge_user: '佐藤花子',
          user_id: 2,
          percentage: 0,
          db_id: 2
        },
        {
          id: 3,
          category_id: 2,
          F1: 'モバイルUI設計',
          start_date: '2025-07-01',
          end_date: '2025-07-28',
          incharge_user: '鈴木一郎',
          user_id: 3,
          percentage: 0,
          db_id: 3
        },
        {
          id: 4,
          category_id: 2,
          F1: 'モバイルアプリ開発',
          start_date: '2025-07-15',
          end_date: '2025-07-25',
          incharge_user: '山田美咲',
          user_id: 4,
          percentage: 0,
          db_id: 4
        },
        {
          id: 5,
          category_id: 3,
          F1: 'コンテンツ制作',
          start_date: '2025-06-10',
          end_date: '2025-07-10',
          incharge_user: '田中太郎',
          user_id: 1,
          percentage: 0,
          db_id: 5
        },
        {
          id: 6,
          category_id: 4,
          F1: 'ユニットテスト',
          start_date: '2025-07-05',
          end_date: '2025-07-20',
          incharge_user: '佐藤花子',
          user_id: 2,
          percentage: 0,
          db_id: 6
        }
      ],
      showDialog: false,
      form: {
        id: '',
        F1: '',
        start_date: '',
        end_date: '',
        incharge_user: '',
        percentage: 0,
        category_id: '',
        user_id: '',
        db_id: ''
      },
      update_mode: false,
      errors: {},
      apiErrorMsg: '',
      loading: false,
      apiErrorMsgForHome: '',
      nextId: 7, // Counter for new task IDs
      nextDbId: 7, // Counter for new DB IDs
    }
  },
  methods: {
    editTask(task) {
      this.update_mode = true;
      this.showDialog = true;
      this.form = { ...task }; // Create a copy to avoid direct mutation
      this.apiErrorMsg = '';
      this.errors = {};
    },
    addTask() {
      this.update_mode = false;
      this.form = {
        id: '',
        F1: '',
        start_date: '',
        end_date: '',
        incharge_user: '',
        percentage: 0,
        category_id: '',
        user_id: '',
        db_id: ''
      };
      this.showDialog = true;
      this.apiErrorMsg = '';
      this.errors = {};
    },
    formValidation() {
      this.errors = {};
      this.apiErrorMsg = '';

      if (!this.form.category_id) {
        this.errors.category_id = 'カテゴリーIDは必須です。';
      }
      if (!this.form.F1) {
        this.errors.F1 = 'タスク名は必須です。';
      }
      if (!this.form.user_id) {
        this.errors.user_id = '担当者は必須です。';
      }
      if (!this.form.start_date) {
        this.errors.start_date = '開始日は必須です。';
      }
      if (!this.form.end_date) {
        this.errors.end_date = '完了期限日は必須です。';
      }

      // Check if start_date is greater than end_date
      if (this.form.start_date && this.form.end_date && new Date(this.form.start_date) > new Date(this.form.end_date)) {
        this.errors.start_date = '開始日は完了期限日より前の日付でなければなりません。';
        this.errors.end_date = '完了期限日は開始日より後の日付でなければなりません。';
      }

      return Object.keys(this.errors).length > 0;
    },
    saveTask() {
      const formValidation = this.formValidation();
      if (formValidation) return;

      this.loading = true;

      // Simulate API delay
      setTimeout(() => {
        const user = this.users.find(user => user.id === this.form.user_id);

        const newTask = {
          id: this.nextId++,
          category_id: this.form.category_id,
          F1: this.form.F1,
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          incharge_user: user ? user.name : '',
          user_id: this.form.user_id,
          percentage: this.form.percentage || 0,
          db_id: this.nextDbId++
        };

        this.tasks.push(newTask);
        this.form = {};
        this.showDialog = false;
        this.loading = false;

        console.log('Task added:', newTask);
        console.log('Current tasks:', this.tasks);
      }, 500);
    },
    updateTask() {
      const formValidation = this.formValidation();
      if (formValidation) return;

      this.loading = true;

      // Simulate API delay
      setTimeout(() => {
        const updatedTaskIndex = this.tasks.findIndex(task => task.id === this.form.id);
        if (updatedTaskIndex !== -1) {
          const user = this.users.find(user => user.id === this.form.user_id);

          const updatedTask = {
            ...this.form,
            incharge_user: user ? user.name : ''
          };

          this.tasks[updatedTaskIndex] = updatedTask;
          this.form = {};
          this.showDialog = false;

          console.log('Task updated:', updatedTask);
        } else {
          this.apiErrorMsg = 'タスクが見つかりません。';
        }
        this.loading = false;
      }, 500);
    },
    deleteTask(taskId) {
      if (confirm('このタスクを削除してもよろしいですか?')) {
        this.loading = true;

        // Simulate API delay
        setTimeout(() => {
          const taskIndex = this.tasks.findIndex(task => task.id === taskId);
          if (taskIndex !== -1) {
            this.tasks.splice(taskIndex, 1);
            this.form = {};
            this.showDialog = false;

            console.log('Task deleted with ID:', taskId);
            console.log('Remaining tasks:', this.tasks);
          } else {
            this.apiErrorMsg = 'タスクが見つかりません。';
          }
          this.loading = false;
        }, 500);
      }
    },
    updateDraggedTask(task) {
      this.form = { ...task };
      this.updateTask();
    }
  },
  mounted() {
    console.log('Component mounted with demo data');
    console.log('Categories:', this.categories);
    console.log('Users:', this.users);
    console.log('Tasks:', this.tasks);
  },
}
</script>

<style>
.base {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: gray;
  opacity: 0.5;
}

.content {
  background-color: white;
  position: relative;
  border-radius: 10px;
  padding: 40px;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>